import React from 'react';
import {
  PreviewPage, PreviewPanel, PreviewTable, PreviewTabs,
} from '../../components/access-denied/preview/PreviewParts';

/** Prévia falsa dos relatórios para a tela de bloqueio (dados de exemplo fixos). */
const ReportsLockedPreview = () => (
  <PreviewPage>
    <PreviewTabs labels={['Leads', 'Agendamentos', 'Financeiro']} />
    <PreviewPanel title="Relatório de exemplo">
      <PreviewTable
        columns={['Data', 'Nome', 'Origem', 'Situação']}
        rows={[
          ['01/01', 'Contato de exemplo', 'Site', 'Novo'],
          ['02/01', 'Contato de exemplo', 'Indicação', 'Em conversa'],
          ['03/01', 'Contato de exemplo', 'Instagram', 'Agendado'],
          ['04/01', 'Contato de exemplo', 'Site', 'Convertido'],
          ['05/01', 'Contato de exemplo', 'Indicação', 'Novo'],
        ]}
      />
    </PreviewPanel>
  </PreviewPage>
);

export default ReportsLockedPreview;
